/* eslint-disable no-console */
export default {
  methods: {
    setTableCellHeight(width) {
      let style = 'height: 65px;';
      if (width <= 960) {
        style = 'height: 65px;';
      }
      return style;
    },
    scrollHorizontally(e) {
      e = window.event || e;
      let delta = Math.max(-1, Math.min(1, (e.wheelDelta || -e.detail)));
      document.getElementById('right-calendar').scrollLeft -= (delta*40); // Multiplied by 40
      /* if((delta > 0 && document.getElementById('right-calendar').scrollLeft > 0)
        || (delta < 0 && document.getElementById('right-calendar')
          .offsetWidth+document.getElementById('right-calendar').scrollLeft < el.scrollWidth)) */
      e.preventDefault();
    },
    calculateColor(day, room) {
      let color = 'background-color:#4CAF50;';
      if (day.availableRooms === '-') {
        color = 'background-color:#e0e0e0;';
      } else if (day.availableRooms === 0) {
        color = 'background-color:#FF5252;';
      } else if (day.availableRooms < (room.quantity / 2)) {
        color = 'background-color:#FFC107;';
      }
      return color;
    },
    getRatesFor(occupancyRate, room) {
      const rates = [];
      if (room !== undefined) {
        if (Object.prototype.toString.call(room.rateMatrix) === '[object String]') {
          room.rateMatrix = JSON.parse(room.rateMatrix);
        }
        for (let i = 0; i < room.rateMatrix.length; i += 1) {
          const rate = room.rateMatrix[i];
          if (rate.occupancyRate === occupancyRate) {
            rates.push(rate);
          }
        }
      }
      return rates;
    },
    setColor(rate, room) {
      if (room !== undefined && rate.percent !== undefined) {
        if (rate.percent === room.rates[0].percent) {
          return 'lowset';
        } else if (rate.percent === room.rates[room.rates.length - 1].percent) {
          return 'highest';
        } else {
          for (let i = 1; i < room.rates.length - 1; i += 1) {
            const tempRate = room.rates[i];
            if (tempRate.percent === rate.percent) {
              if (i === 1) {
                return 'random1';
              } else if (i === 2) {
                return 'random2';
              } else if (i === 3) {
                return 'random3';
              } else if (i === 4) {
                return 'random4';
              } else if (i === 5) {
                return 'random5';
              } else if (i === 6) {
                return 'random6';
              } else {
                return 'random';
              }
            }
          }
        }
      }
      return 'default';
    },
    hasEvent(day) {
      return day !== undefined && day.eventPercent > 0;
    },
    hasMinStay(day) {
      return day.minimumStay !== '';
    },
    getCategoryLabel(cat) {
      let label = 'Standardeinstellung';
      if (cat === 'OPEN') {
        label = 'Geöffnet';
      } else if (cat === 'CLOSE') {
        label = 'Geschlossen';
      }
      return label;
    },
    getMinOccupancyNights(rules, day) {
      const rulesTemp = JSON.parse(JSON.stringify(rules));
      rulesTemp.sort((a, b) => {
        return a.rate - b.rate;
      });
      let label = '';
      for (let i = 0; i < rulesTemp.length; i += 1) {
        let rule = rulesTemp[i];
        if (rule.rate >= day.occupancyRate) {
          label = label.concat(rule.minimum);
          if (rule.minimum > 1) {
          label = label.concat(' Nächte');
          } else {
            label = label.concat(' Nacht');
          }
          break;
        }
      }
      return label;
    },
    hasLand(region) {
      return region === 'AT' || region === 'IT' || region === 'DE' || region === 'CH';
    },
  }
}
